import { MensagemService } from './../../../../../shared/services/mensagem.service';
import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { environment } from '@environments/environment';

import { DependenteService } from '@app/shared/services';

import { Censo, ConfigCamposFormulario, Dependente, Loading, Segurado } from '@app/shared/models';

import { AdicionarDependenteComponent } from '../adicionar-dependente/adicionar-dependente.component';
import { ExcluirDependenteComponent } from '../excluir-dependente/excluir-dependente.component';

@Component({
  selector: 'app-form-dependentes',
  templateUrl: './form-dependentes.component.html',
  styleUrls: ['./form-dependentes.component.scss']
})
export class FormDependentesComponent implements OnInit {

  @Input() formEtapa5: FormGroup;
  @Input() dependentes: Dependente[];
  @Input() mostrarListaDependentes: boolean;
  @Input() segurado: Segurado;
  @Input() configCamposFormulario: ConfigCamposFormulario[];
  @Input() censo: Censo;

  cliente = environment.cliente;

  carregar = new Loading();

  constructor(
    private dependenteService: DependenteService,
    private mensagemService: MensagemService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  private abrirDialogAdicionarDependente(dep: Dependente, listaDependentes: Dependente[], segurado: Segurado): MatDialogRef<AdicionarDependenteComponent> {
    return this.dialog.open(AdicionarDependenteComponent, {
      width: '500px',
      data: { dependente: dep, listaDependentes: listaDependentes, segurado: this.segurado, configCamposFormulario: this.configCamposFormulario},
      panelClass: 'custom-dependentes-modal',
      closeOnNavigation: false,
      disableClose: true
    });
  }

  private abrirDialogRemoverDependente(dep: Dependente, segurado: Segurado): MatDialogRef<ExcluirDependenteComponent> {
    return this.dialog.open(ExcluirDependenteComponent, {
      width: '500px',
      data: { dependente: dep, segurado: segurado},
      panelClass: 'custom-dependentes-modal',
      closeOnNavigation: false,
      disableClose: true
    });
  }

  adicionarOuAtualizarDependente(dep?: Dependente): void {
    const dialogRef = this.abrirDialogAdicionarDependente(dep, this.dependentes, this.segurado);
    dialogRef.afterClosed().subscribe((result: Dependente) => {
      if (result) {
        if (this.dependentes.find(v => v.id === result.id)) {
          const index = this.dependentes.findIndex(v => v.id === result.id);
          this.dependentes[index] = result;
        } else {
          this.dependentes.push(result);
        }
      }
    });
  }

  removerDependente(dep: Dependente): void {
    this.mensagemService.avisoMensagemCondicional(
      'Antes de seguir para a próxima etapa, você confirma que verificou as informações digitadas?',
      'Atenção',
      'warning'
    ).then((response) => {
      if (response.value) {
        const dialogRef = this.abrirDialogRemoverDependente(dep, this.segurado);

        dialogRef.afterClosed().subscribe((formMotivoValue: any) => {
          if(formMotivoValue !== null) {
            const index = this.dependentes.findIndex(v => v.id === dep.id);
            this.dependentes.splice(index, 1);
          }
        });
      }
    });
  }
}
